import moment from 'moment';
import { Container, LegacyContainerStatus } from 'types/Watchlist';

import Anchor from 'assets/emojis/anchor.png';
import GatedOut from 'assets/emojis/gated-out.png';
import Pending from 'assets/emojis/pending.png';
import Terminated from 'assets/emojis/terminated.png';
import Vessel from 'assets/emojis/vessel.png';

interface StatusMapping {
  label: string;
  image: string;
  tooltip?: string;
}

export const statusMapping = (
  container: Container,
  status: LegacyContainerStatus
): StatusMapping => {
  const { transactionCreatedAt } = container;

  if (transactionCreatedAt && moment().diff(moment(transactionCreatedAt), 'seconds') <= 30) {
    return { label: 'Loading…', image: Pending };
  }

  switch (status) {
    case LegacyContainerStatus.OnVessel:
      return { label: 'On Vessel', image: Vessel };
    case LegacyContainerStatus.GatedOut:
      return { label: 'Gated Out', image: GatedOut };
    case LegacyContainerStatus.Import:
      return { label: 'Arrived', image: Anchor };
    case LegacyContainerStatus.Terminated:
      return { label: 'Terminated', image: Terminated };
    default:
      return { label: 'Not found yet', image: Pending };
  }
};
